@if ($error(); as error) {
  <osp-messages
    class="p-error"
    [messages]="[{ severity: 'error', detail: error }]"
    [enableService]="false"
    [closable]="false"
  />
}
